import {supplyEventInAction} from "@/components/common/controlBar/controlBarDialog/event/washData.js";

export function washData_container(walkedNode) {

  supplyEventInAction(walkedNode)
}
